module.exports = __webpack_public_path__ + "static/media/JNTRB_jointer_smartswap.a8d021a9.png";